import { Controller } from "@hotwired/stimulus"

// Expand/collapse for the "+ Project" form and the request-type editors. Deliberately has no
// memory: an open editor is not a preference, it is where you happen to be mid-edit, so it starts
// closed on every render. The sidebar's project rows are the case that DOES need remembering, and
// they use `project-disclosure`, whose state the server can read.
export default class extends Controller {
  static targets = ["content", "focus"]

  toggle() {
    this.setOpen(this.contentTarget.hidden)
  }

  setOpen(open) {
    this.contentTarget.hidden = !open
    this.element.classList.toggle("is-open", open)

    const button = this.element.querySelector("[aria-expanded]")
    if (button) button.setAttribute("aria-expanded", open ? "true" : "false")

    if (!open) return

    if (this.hasFocusTarget) this.focusTarget.focus()
    // Focusing the first field scrolls only that field into view, which is not the same as making
    // the editor usable: a request type's editor is several rows tall, and opening one near the
    // bottom of the settings pane left its colour swatches below the fold with nothing to suggest
    // they were there. Pull the whole revealed block into view instead.
    this.contentTarget.scrollIntoView({ block: "nearest", behavior: "instant" })
  }
}
